/* DON'T EDIT THIS FILE: edit original and run build again */ const rulebookValueOptions = {
  fciMomentumPymes: {
    label:
      "Fondo Común de Inversión Abierto FCI Momentum Pymes (aprobado por resolución de la CNV N° RESFC-2021-21357-APN-DIR#CNV del 19-08-2021)",
  },
  fciIebAhorro: {
    label:
      "Fondo Común de Inversión Abierto IEB Ahorro (aprobado por la Comisión Nacional de Valores por Disposición N° DI-2024-67-APN-GFCI#CNV de fecha 05/09/2024 Reglamento de Gestión aprobado por la Comisión Nacional de Valores por Resolución N° 20638 de fecha 12/02/2020 e inscripto en el registro de la Comisión Nacional de Valores con el N° 1142)",
  },
  fciIebAhorroPlus: {
    label:
      "Fondo Común de Inversión Abierto IEB Ahorro Plus (aprobado por la Comisión Nacional de Valores por Disposición N° DI-2024-67-APN-GFCI#CNV de fecha 05/09/2024 Reglamento de Gestión aprobado por la Comisión Nacional de Valores por Resolución N° 19504 de fecha 10/05/2018 e inscripto en el registro de la Comisión Nacional de Valores con el N° 1041)",
  },
  fciIebRetornoTotal: {
    label:
      "Fondo Común de Inversión Abierto IEB Retorno Total (aprobado por la Comisión Nacional de Valores por Disposición N° DI-2024-67-APN-GFCI#CNV de fecha 05/09/2024 Reglamento de Gestión aprobado por la Comisión Nacional de Valores por Resolución N° 19504 de fecha 10/05/2018 e inscripto en el registro de la Comisión Nacional de Valores con el N° 1042)",
  },
  fciIebRentaFija: {
    label:
      "Fondo Común de Inversión Abierto IEB Renta Fija aprobado por la Comisión Nacional de Valores por Disposición N° DI-2024-67-APN-GFCI#CNV de fecha 05/09/2024 Reglamento de Gestión aprobado por la Comisión Nacional de Valores por Resolución N° 20208 de fecha 24/04/2019 e inscripto en el registro de la Comisión Nacional de Valores con el N° 1103",
  },
  fciIebRentaFijaDolar: {
    label:
      "Fondo Común de Inversión Abierto IEB Renta Fija Dólar (aprobado por la Comisión Nacional de Valores por Disposición N° DI-2024-67-APN-GFCI#CNV de fecha 05/09/2024 Reglamento de Gestión aprobado por la Comisión Nacional de Valores por Resolución N° 20208 de fecha 24/04/2019 e inscripto en el registro de la Comisión Nacional de Valores con el N° 1104)",
  },
  fciIebRentaFijaDolar2: {
    label:
      "Fondo Común de Inversión Abierto IEB Renta Fija Dólar 2 (aprobado por la Comisión Nacional de Valores por Resolución N° 21971 de fecha 05/10/2022 e inscripto en el registro de la Comisión Nacional de Valores con el N° 1346)",
  },
  fciIebMultiestrategia: {
    label:
      "Fondo Común de Inversión Abierto IEB Multiestrategia (aprobado por la Comisión Nacional de Valores por Disposición N° DI-2024-67-APN-GFCI#CNV de fecha 05/09/2024 Reglamento de Gestión aprobado por la Comisión Nacional de Valores por Resolución N° 20196 de fecha 17/04/2019 e inscripto en el registro de la Comisión Nacional de Valores con el N° 1101)",
  },
  fciIebMultiestrategia2: {
    label:
      "Fondo Común de Inversión Abierto IEB Multiestrategia II (aprobado por la Comisión Nacional de Valores por Resolución N° 22568 de fecha 20/12/2023 e inscripto en el registro de la Comisión Nacional de Valores con el N° 1474)",
  },
  fciIebMultiestrategia3: {
    label:
      "Fondo Común de Inversión Abierto IEB Multiestrategia III (aprobado por la Comisión Nacional de Valores por Disposición N° DI-2024-67-APN-GFCI#CNV de fecha 05/09/2024 Reglamento de Gestión aprobado por la Comisión Nacional de Valores por Resolución N° 21849 de fecha 06/07/2022 e inscripto en el registro de la Comisión Nacional de Valores con el N° 1316",
  },
  fciIebMultiestrategia4: {
    label:
      "Fondo Común de Inversión Abierto IEB Multiestrategia IV (aprobado por la Comisión Nacional de Valores por Resolución N° 22568 de fecha 20/12/2023 e inscripto en el registro de la Comisión Nacional de Valores con el N° 1476)",
  },
  fciIebMultiestrategia5: {
    label:
      "Fondo Común de Inversión Abierto IEB Multiestrategia V (aprobado por la Comisión Nacional de Valores por Resolución N° 21849 de fecha 06/07/2022 e inscripto en el registro de la Comisión Nacional de Valores con el N° 1318)",
  },
  fciIebAbiertoPyme: {
    label:
      "Fondo Común de Inversión Abierto IEB Fondo Común de Inversión Abierto Pyme (aprobado por la Comisión Nacional de Valores por Disposición N° DI-2024-67-APN-GFCI#CNV de fecha 05/09/2024 Reglamento de Gestión aprobado por la Comisión Nacional de Valores por Resolución N° 20838 de fecha 22/10/2020 e inscripto en el registro de la Comisión Nacional de Valores con el N° 1168)",
  },
  fciIebValue: {
    label:
      "Fondo Común de Inversión Abierto IEB Value (o aprobado por la Comisión Nacional de Valores por Disposición N° DI-2024-67-APN-GFCI#CNV de fecha 05/09/2024 Reglamento de Gestión aprobado por la Comisión Nacional de Valores por Resolución N° 20208 de fecha 24/04/2019 e inscripto en el registro de la Comisión Nacional de Valores con el N° 1102)",
  },
  fciIebEstrategico: {
    label:
      "Fondo Común de Inversión Abierto IEB Estratégico (aprobado por la Comisión Nacional de Valores por Disposición N° DI-2024-67-APN-GFCI#CNV de fecha 05/09/2024 Reglamento de Gestión aprobado por la Comisión Nacional de Valores por Resolución N° 22721 de fecha 29/05/2024 e inscripto en el registro de la Comisión Nacional de Valores con el N° 1527)",
  },
  fciAbiertoZofingenPesos24: {
    label:
      "Fondo Común de Inversión Abierto Zofingen Pesos 24 (APROBADO POR LA COMISIÓN NACIONAL DE VALORES SEGÚN RESOLUCIÓN 19347 del 19/02/2018 Registro n° 1029. ADENDA DE MODIFICACIONES APROBADA POR RESOLUCIÓN RESFC-2020-20740-APN-DIR#CNV DEL 5-8-2020.)",
  },
  fciAbiertoZofingenMultiStrategy: {
    label:
      "Fondo Común de Inversión Abierto Zofingen Multi Strategy I (Aprobado por Resolución de la Comisión Nacional de Valores “RESFC-2022 - 21826 -APN-DIR#CNV” de fecha 15 de junio de 2022)",
  },
  fciAbiertoZofingenDollarLinked: {
    label:
      "Fondo Común de Inversión Abierto Zofingen Dollar Linked (Aprobado por Resolución de la Comisión Nacional de Valores “RESFC-2022 - 21826 -APN-DIR#CNV” de fecha 15 de junio de 2022)",
  },
  fciAbiertoZofingenFactoring: {
    label:
      "Fondo Común de Inversión Abierto Zofingen Factoring Abierto Pyme (APROBADO POR LA COMISIÓN NACIONAL DE VALORES SEGÚN RESOLUCIÓN RESFC-2019-20357-APN-DIR#CNV DEL 24/7/2019 Registro n° 1015)",
  },
  fciAbiertoZofingenPesosYa: {
    label:
      "Fondo Común de Inversión Abierto Zofingen Pesos YA (AUTORIZADO POR RESOLUCIÓN RESFC-2024-22862-APN-DIR#CNV DE FECHA 11 DE SEPTIEMBRE DE 2024 DE LA COMISIÓN NACIONAL DE VALORES)",
  },
};

export default rulebookValueOptions;
